import React, { useState, useEffect } from 'react';
import {
    Grid,
} from '@mui/material';
import Collapse from '@mui/material/Collapse';
import { ButtonLoading, SimpleDialog, Icons } from 'components';
import services from '../../services/Services';
import { useStyles } from './Style';

export default function VersionDialog({ data, isLoading, setData, open, setOpen }) {
    const classes = useStyles();
    const [isSeen, setIsSeen] = useState(false);
    const [isLoadingBtn, setIsLoadingBtn] = useState(false);

    useEffect(() => {
        if (!isLoading) {
            setIsSeen(!data[0]?.isSeen)
        }
    }, [data])

    const agreeVersion = (item) => {
        setIsLoadingBtn(true)
        if (isSeen) {
            services
                .postAgreeVersion(item[0]?.version)
                .then(() => {
                    setIsSeen(false)
                    setOpen(false);
                })

                .finally(() => {
                    setIsLoadingBtn(false)

                });

        } else {
            setIsSeen(false)
            setOpen(false);
            setIsLoadingBtn(false)
        }


    }


    /**
 * به ازای هر آیتم کشویی میسازد
 */
    const collpaseItem = (data, index) => {
        return (
            <Grid
                item
                container
                xs={12}
                style={{ border: '1px solid #ccc', borderRadius: '5px' }}
            >
                <Grid
                    item
                    xs={12}
                    className={classes.headItem}

                >
                    <span> تغییرات  نسخه:   </span>

                </Grid>
                <Collapse style={{ width: '100%' }} in={true} timeout="auto" >
                    {data?.features && data?.features.length > 0 && (
                        <Grid className={classes.mr4}>
                            <Grid className={classes.mr8}>
                                {data.features.map((valueItem, index) => {
                                    return (
                                        <div className={classes.subItem}>
                                            <span className={classes.fonticon8}>
                                                <Icons icon="Accept" color="#2B398E" size="20" />
                                            </span> {valueItem.title}
                                        </div>
                                    );
                                })}
                            </Grid>
                        </Grid>
                    )}
                    {data?.refiments && data?.refiments.length > 0 && (
                        <Grid className={classes.mr4}>
                            <Grid className={classes.mr8}>
                                {data.refiments.map((valueItem, index) => {
                                    return (
                                        <div className={classes.subItem}>
                                            <span className={classes.fonticon8}>
                                                <Icons icon="Accept" color="#2B398E" size="20" />
                                            </span>{valueItem.title}
                                        </div>
                                    );
                                })}
                            </Grid>
                        </Grid>
                    )}
                    {data?.bugs && data?.bugs.length > 0 && (
                        <Grid className={classes.mr4}>
                            <Grid className={classes.mr8}>
                                {data.bugs.map((valueItem, index) => {
                                    return (
                                        <div className={classes.subItem}>
                                            <span className={classes.fonticon8}>
                                                <Icons icon="Accept" color="#2B398E" size="20" />
                                            </span>{valueItem.title}
                                        </div>
                                    );
                                })}
                            </Grid>
                        </Grid>
                    )}
                </Collapse>
            </Grid >
        );
    };
    const BtnActions = () => {
        return (
            <ButtonLoading
                variant="contained"
                color="primary"
                loading={isLoadingBtn}
                name="متوجه شدم"
                onClick={() => { agreeVersion(data) }}
            />
        );
    };
    return (
        <SimpleDialog
            title={'بروزرسانی پنل '}
            icon={<Icons icon="SuccessStar" color="#2B398E" />}
            open={isSeen || open}
            actions={<BtnActions />}>
            <Grid className={classes.blockDialog}>
                <div className={classes.blockVersion}>
                    <div className={classes.blockVersionLogo}>
                        <img alt="Logo" className={classes.logo} src="../images/pod/logo-white.svg" />
                    </div>
                    <div className={classes.blockVersionText}>
                        <h4>نسخه جدید پنل کسب و کار پاد</h4>
                        <span>{data[0]?.version}</span>
                    </div>
                </div>
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                    spacing={2}
                    item
                    className={classes.CollapseMain} >
                    {data &&
                        data.map((valueItem, index) => {
                            return collpaseItem(valueItem, index);
                        })}
                </Grid>
            </Grid>


        </SimpleDialog>
    );
}
